import moment from "moment"
import React from "react"

export function jsonFormatRoom(room) {
    return {
        id: room.id,
        //label: room.label ?? false, // manca a BE
        images: room.images ?? [], // manca a BE
        options: {
            type: room.type ?? room.type ? formatRoomType(room.type) : "",
            title: room.title ?? "",
            address: room.address ? formatAddress(room.address) : undefined,
            lat: room.location ? room.location.lat : undefined,
            lng: room.location ? room.location.lng : undefined,
            mq: room.attributes.surfaceArea ?? 0,
            mates: room.attributes.numTenants ?? 0,
            rooms: room.attributes.numRooms ?? 0,
            floor: room.attributes.numFloors ?? 0,
            bathrooms: room.attributes.numBathrooms ?? 0,
            washing_machine: room.attributes.hasWashingMachine ?? false,
            air_conditioning: room.attributes.hasAirConditioning ?? false,
            tv: room.attributes.hasTv ?? false,
            central_heating: room.hasCentralHeating ?? false,
            price: room.rent ?? 0,
            description: room.description ?? "",
            features: [
                {
                    type: "type",
                    label: room.type ? formatRoomType(room.type) : undefined,
                },
                {
                    type: "beds",
                    label: room.attributes.numBeds
                        ? room.attributes.numBeds + " letti"
                        : undefined,
                },
                {
                    type: "availability",
                    label: room.availability
                        ? "Disponibile dal " + room.availability
                        : undefined,
                },
                {
                    type: "duration",
                    label: room.attributes.minStay
                        ? "Soggiorno minimo: " +
                          room.attributes.minStay +
                          " mesi"
                        : undefined,
                },
            ],
            featuresTeaser: [
                {
                    type: "air-conditioning",
                    label: room.attributes.hasAirConditioning
                        ? "Aria condizionata"
                        : undefined,
                },
                {
                    type: "washing-machine",
                    label: room.attributes.hasWashingMachine
                        ? "Lavatrice"
                        : undefined,
                },
                { type: "tv", label: room.attributes.hasTv ? "TV" : undefined },
                {
                    type: "central-heating",
                    label: room.attributes.hasCentralHeating
                        ? "Riscaldamento centralizzato"
                        : undefined,
                },
                {
                    type: "garden",
                    label: room.attributes.hasGarden ? "Giardino" : undefined,
                },
                {
                    type: "parking",
                    label: room.attributes.hasParkingSpot
                        ? "Parcheggio"
                        : undefined,
                },
                {
                    type: "wifi",
                    label: room.attributes.hasWifi ? "Wi-Fi" : undefined,
                },
            ],
        },
    }
}

export function jsonFormatContactRequest(request, handled) {
    return {
        key: request.id,
        data: fromatDate(request.createdAt),
        birthDate: fromatBirthday(request.birthDate),
        fullName: request.fullName,
        email: request.email,
        roomID: request.room.id,
        handled: handled,
        rawData: {
            ...request,
            startDate: moment(request?.startDate),
            endDate: moment(request?.endDate),
        },
    }
}

// =================================================================

function formatAddress(address) {
    const tmp = [address.address, address.city, address.region]
    return tmp.join(", ")
}

function formatRoomType(type) {
    const types = {
        apartment: "Appartamento",
        room: "Stanza",
    }
    return types[type]
}

function fromatDate(date) {
    return (
        <>
            {moment(date).format("DD/MM/YYYY")}
            <br />
            {moment(date).format("hh:mm A")}
        </>
    )
}

function fromatBirthday(date) {
    return moment(date).format("DD/MM/YYYY")
}
